import React, { useState, useEffect, useMemo, useCallback } from "react";
import CardTable from "components/CardTable/CardTable";
import { useOpenComponent } from "hooks/useOpenComponent";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";
import { columns } from "./columns";

import { Home } from "@mui/icons-material";
import { useSearch } from "hooks/useSearch";
import { ModalV2 } from "components/Modal/ModalV2";
import { COVERAGES_ASSIGN_PHRASE } from "./config";
import {
    fetchCoveragesAssign,
    deleteAssignedCoverage,
    newAssignation,
    setCoveragesAssignFilters
} from "redux/actions/coveragesAssign/coveragesAssignActions";
import { FormAssignEdit } from './FormAssignPage'
import RegularButton from "components/CustomButtons/Button";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
const TABLE_KEY = "coveragesAssign";
const LOADINGS = [
    "fetchCoveragesAssign",
];

export const CoveragesAssignPage = () => {
    const dispatch = useDispatch();
    const { isOpen, handleIsOpen } = useOpenComponent();
    const {
        buildCompLoadings,
        setSnackbar
    } = useSearch();
    const { addMode, assignedCoverages, statusList, assignedCoverageSelected, startDate, endDate, station } = useSelector(state => state.coveragesAssign);
    const { isLoadingComp } = useSelector(state => state.search);
    const [openDelete, setOpenDelete] = useState(false);

    const coveragesAssignMemo = useMemo(
        () =>
            assignedCoverages.map(assignedCoverage => {
                return {
                    ...assignedCoverage,
                    statusName: statusList.find(obj => obj.value == assignedCoverage.status)?.label,
                    modal: handleIsOpen,
                    deleteModal: setOpenDelete
                };
            }),
        [assignedCoverages, statusList, handleIsOpen]
    );

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
        if (!station) return setSnackbar("Seleccione una planta", "warning");
        dispatch(fetchCoveragesAssign({ startDate, endDate, station, page: 0, limit: 9999, tableKey: TABLE_KEY }));
    }, [dispatch, startDate, endDate, station, setSnackbar]);

    const handleDelete = useCallback(() => {
        dispatch(deleteAssignedCoverage(assignedCoverageSelected.id, setOpenDelete))
    }, [dispatch, assignedCoverageSelected]);

    useEffect(() => {
        buildCompLoadings(LOADINGS);
    }, []);

    const handleOpenClick = useCallback(() => {
        dispatch(newAssignation())
        handleIsOpen()
    }, [dispatch, handleIsOpen]);
    
    return (
        <React.Fragment>
            <CardTable
                data={coveragesAssignMemo}
                columns={columns}
                loading={isLoadingComp?.fetchCoveragesAssign}
                title={COVERAGES_ASSIGN_PHRASE.page.table.title}
                icon={<Home />}
                hasHeader
                blockBtn
                tableKey={TABLE_KEY}
                tableContent={
                    <TableInputs
                        reducer="coveragesAssign"
                        dates
                        stations
                        dispatchAction={setCoveragesAssignFilters}
                        submitAction={handleSubmit}
                        loading={isLoadingComp?.fetchCoveragesAssign}
                    />
                }
                hasControl
                controls={ 
                    <RegularButton round justIcon color="info" onClick={handleOpenClick}>
                        <AddIcon style={{ margin: 0 }} />
                    </RegularButton>
                }
            />
            <ModalV2
                open={isOpen}
                onClose={handleIsOpen}
                toRight
                title={addMode ? 'Asignar cobertura' : 'Modificar asignación'}
            >
                <FormAssignEdit handleClose={handleIsOpen} />
            </ModalV2>
            <ModalV2
                title={"¿Estas seguro de eliminar la asignación?"}
                justConfirm
                open={openDelete}
                onClose={() => setOpenDelete(false)}
                minHeight={2}
                textAlign="center"
                textMargin={28}
                onSubmit={handleDelete}
            />
        </React.Fragment>
    );
};
